import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message } from 'primeng/api';
import { StorageService } from '../../../../services/system/storage.service';
import { ListingCategory } from '../../../../models/inModels/MarketPlaceModel';
import { ListingCategoryService } from '../../../../services/listing-categories/listing-category.service';

@Component({
  selector: 'app-create-listing-category',
  templateUrl: './create-listing-category.component.html',
})
export class CreateListingCategoryComponent implements OnInit {
  model: ListingCategory;
  loading = false;
  error: Message[];
  messages: Message[];
  groupId: number;
  constructor(
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ListingCategoryService) {
    }
    
  ngOnInit() {
    this.groupId = this.route.snapshot.params.groupId;
    this.model = new ListingCategory();
    this.model.GroupId = this.groupId;
    this.model.Enabled = true;
  }

  goBack(): void {
    this.router.navigate(['/marketplace/listing-category/group/edit', this.model.GroupId]);
  }

  save() {
    this.loading = true;
    this.service.createCategory(this.model).then(
      res => {
        this.model = new ListingCategory(res);
        this.loading = false;
        this.goBack();
      },
      error => {
        this.loading = false;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      });
  }

  handleDisplayImage(event): void {
    var result = this.storageService.handleSuccess(event);
    this.model.ImageId = result.PublicId;
    this.loading = false;
  }
    
  handleError(event): void {
    this.loading = false;
    this.error = [];
    this.storageService.handleError(event, this.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/components/listing-categories/create/create-category/create-listing-category.component.ts